export default {
  // ── Navigation ────────────────────────────────────────────────────
  'landing.nav.features': 'Features',
  'landing.nav.architecture': 'Architecture',
  'landing.nav.scenarios': 'Use Cases',
  'landing.nav.ecosystem': 'Ecosystem',
  'landing.nav.cases': 'Case Studies',
  'landing.nav.pricing': 'Pricing',
  'landing.nav.login': 'Sign In',
  'landing.nav.freeTrial': 'Free Trial',

  // ── Stats ─────────────────────────────────────────────────────────
  'landing.stats.efficiency.label': 'Avg. Efficiency Gain',
  'landing.stats.efficiency.desc': 'vs. traditional manual methods',
  'landing.stats.accuracy.label': 'Knowledge Retrieval Accuracy',
  'landing.stats.accuracy.desc': 'Enterprise private knowledge Q&A',
  'landing.stats.customers.label': 'Enterprise Customers',
  'landing.stats.customers.desc': 'Across 10+ industries',

  // ── Hero ──────────────────────────────────────────────────────────
  'landing.hero.badge': 'Enterprise AI Collaboration Platform',
  'landing.hero.title.line1': 'Give Every Team',
  'landing.hero.title.line2': 'Their Own',
  'landing.hero.title.highlight': 'AI Brain',
  'landing.hero.subtitle': 'Unify knowledge bases, document processing, and intelligent Q&A to eliminate repetitive work and accelerate knowledge flow across your organization.',
  'landing.hero.stat.customers': 'Enterprise Clients',
  'landing.hero.stat.uptime': 'Service Uptime',
  'landing.hero.stat.efficiency': 'Efficiency Boost',
  'landing.hero.cta.start': 'Free Trial',
  'landing.hero.cta.demo': 'Book a Demo',
  'landing.hero.trust.appstore': '4.9 · App Store Rating',
  'landing.hero.trust.noCard': 'No credit card required',
  'landing.hero.badge.todayDocs': 'Documents Processed Today',
  'landing.hero.badge.increase': '↑ 12% vs. yesterday',
  'landing.hero.badge.contractDone': 'Contract Auto-Review Complete',
  'landing.hero.badge.timeSaved': 'Just now · Saved 2.5 hours',
  'landing.hero.trusted': 'Trusted by Industry Leaders',
  'landing.hero.preview.placeholder': 'Product Screenshot / Demo Video',
  'landing.hero.preview.hint': 'Replace img src to show real content',

  // ── Features ──────────────────────────────────────────────────────
  'landing.features.badge': 'Core Features',
  'landing.features.title': 'Redefining Enterprise AI Capabilities',
  'landing.features.subtitle': 'Six core capability modules covering the full spectrum of enterprise AI transformation — ready to use, fast to integrate',
  'landing.features.learnMore': 'Learn more →',

  'landing.feature.knowledge.title': 'Intelligent Knowledge Assistant',
  'landing.feature.knowledge.desc': 'Build a dedicated AI assistant from your private knowledge base — accurate Q&A, instant responses, no more information silos.',
  'landing.feature.knowledge.tag1': 'RAG Retrieval',
  'landing.feature.knowledge.tag2': 'Multi-turn Dialogue',
  'landing.feature.knowledge.tag3': 'Source Citation',

  'landing.feature.document.title': 'Intelligent Document Processing',
  'landing.feature.document.desc': 'Auto-parse PDF, Word, Excel and more — extract structured data and process documents 10× faster at scale.',
  'landing.feature.document.tag1': 'OCR Recognition',
  'landing.feature.document.tag2': 'Auto Summary',
  'landing.feature.document.tag3': 'Structure Extraction',

  'landing.feature.workflow.title': 'Workflow Automation',
  'landing.feature.workflow.desc': 'Connect existing enterprise systems and build AI-driven automated workflows to cut repetitive tasks and free your team\'s creativity.',
  'landing.feature.workflow.tag1': 'Workflow Orchestration',
  'landing.feature.workflow.tag2': 'System Integration',
  'landing.feature.workflow.tag3': 'Scheduled Tasks',

  'landing.feature.security.title': 'Enterprise-Grade Security',
  'landing.feature.security.desc': 'Private deployment support, data never leaves your infrastructure, meeting compliance requirements for finance, healthcare, and government.',
  'landing.feature.security.tag1': 'Private Deployment',
  'landing.feature.security.tag2': 'Data Masking',
  'landing.feature.security.tag3': 'Audit Logs',

  'landing.feature.model.title': 'Multi-Model Management',
  'landing.feature.model.desc': 'Unified access to GPT-4, Claude, Wenxin, Tongyi and other leading LLMs with intelligent routing and on-demand switching.',
  'landing.feature.model.tag1': 'Model Routing',
  'landing.feature.model.tag2': 'Cost Optimization',
  'landing.feature.model.tag3': 'A/B Testing',

  'landing.feature.analytics.title': 'Data Analytics & Insights',
  'landing.feature.analytics.desc': 'Query databases in natural language, generate chart reports in one sentence — turn everyone into a data analyst.',
  'landing.feature.analytics.tag1': 'NL2SQL',
  'landing.feature.analytics.tag2': 'Visualization',
  'landing.feature.analytics.tag3': 'Report Generation',

  // ── Architecture ──────────────────────────────────────────────────
  'landing.arch.badge': 'Platform Architecture',
  'landing.arch.title': 'Four-Layer Architecture, Rock-Solid Reliability',
  'landing.arch.subtitle': 'Click each layer to explore its capabilities and understand the full tech stack',
  'landing.arch.integrations': 'Enterprise Systems · DingTalk · Lark · WeChat · Custom API',

  'landing.arch.app.label': 'Application Layer',
  'landing.arch.app.sublabel': 'Application Layer',
  'landing.arch.app.item.0': 'Knowledge Assistant',
  'landing.arch.app.item.1': 'Document Intelligence',
  'landing.arch.app.item.2': 'Process Bot',
  'landing.arch.app.item.3': 'Data Analytics',
  'landing.arch.app.desc': 'Business-facing AI apps for rapid custom deployment. Supports web, mobile, and API access channels.',

  'landing.arch.platform.label': 'Platform Layer',
  'landing.arch.platform.sublabel': 'Platform Layer',
  'landing.arch.platform.item.0': 'Prompt Management',
  'landing.arch.platform.item.1': 'Dialogue Orchestration',
  'landing.arch.platform.item.2': 'Workflow Engine',
  'landing.arch.platform.item.3': 'Access Control',
  'landing.arch.platform.desc': 'Core platform capabilities: low-code AI app builder, model routing & cost optimization, end-to-end monitoring.',

  'landing.arch.model.label': 'Model Layer',
  'landing.arch.model.sublabel': 'Model Layer',
  'landing.arch.model.item.0': 'GPT-4o',
  'landing.arch.model.item.1': 'Claude 3.5',
  'landing.arch.model.item.2': 'Wenxin Yiyan',
  'landing.arch.model.item.3': 'Tongyi Qianwen',
  'landing.arch.model.desc': 'Unified access to mainstream LLMs, private deployment of open-source models, intelligent routing to reduce inference cost.',

  'landing.arch.data.label': 'Data Layer',
  'landing.arch.data.sublabel': 'Data Layer',
  'landing.arch.data.item.0': 'Vector Database',
  'landing.arch.data.item.1': 'Enterprise Knowledge Base',
  'landing.arch.data.item.2': 'Structured Data',
  'landing.arch.data.item.3': 'File Storage',
  'landing.arch.data.desc': 'Unified enterprise data governance, vector indexing for fast retrieval, ensuring AI answers are traceable, auditable, and secure.',

  // ── Scenarios ─────────────────────────────────────────────────────
  'landing.scenarios.badge': 'Use Cases',
  'landing.scenarios.title': 'Covering Every Enterprise AI Scenario',
  'landing.scenarios.subtitle': 'From personal productivity tools to full-process automation, tailored for organizations of any size',
  'landing.scenarios.viewSolution': 'View Full Solution →',
  'landing.scenarios.coreCaps': 'Core Capabilities',
  'landing.scenarios.implemented': '200+ enterprises live in this scenario',
  'landing.scenarios.caseLib': 'Case Library →',

  'landing.scenario.office.tab': 'Enterprise AI Office',
  'landing.scenario.office.title': 'An AI Assistant for Every Employee',
  'landing.scenario.office.desc': 'Smart meeting minutes, email drafting, report generation, schedule management — automate tedious tasks and let your team focus on high-value work.',
  'landing.scenario.office.metric.0.label': 'Reduction in Repetitive Work',
  'landing.scenario.office.metric.0.value': '68%',
  'landing.scenario.office.metric.1.label': 'Document Processing Speed',
  'landing.scenario.office.metric.1.value': '10x',
  'landing.scenario.office.metric.2.label': 'Employee Satisfaction',
  'landing.scenario.office.metric.2.value': '94%',
  'landing.scenario.office.feature.0': 'Smart Meeting Assistant',
  'landing.scenario.office.feature.1': 'Auto Email Reply',
  'landing.scenario.office.feature.2': 'One-click Report Generation',
  'landing.scenario.office.feature.3': 'PPT Content Assistant',
  'landing.scenario.office.feature.4': 'Multi-language Translation',
  'landing.scenario.office.feature.5': 'Intelligent Scheduling',

  'landing.scenario.knowledge.tab': 'Knowledge Assistant',
  'landing.scenario.knowledge.title': 'Bring Your Enterprise Knowledge to Life',
  'landing.scenario.knowledge.desc': 'Connect product manuals, policies, and industry literature to build a dedicated Q&A system. New hires onboard in one day; customer service response 5× faster.',
  'landing.scenario.knowledge.metric.0.label': 'Knowledge Retrieval Accuracy',
  'landing.scenario.knowledge.metric.0.value': '97%',
  'landing.scenario.knowledge.metric.1.label': 'New Hire Training Speed',
  'landing.scenario.knowledge.metric.1.value': '75%',
  'landing.scenario.knowledge.metric.2.label': 'Customer Service Speed',
  'landing.scenario.knowledge.metric.2.value': '5x',
  'landing.scenario.knowledge.feature.0': 'Multi-format Document Import',
  'landing.scenario.knowledge.feature.1': 'Intelligent Vector Search',
  'landing.scenario.knowledge.feature.2': 'Source Citation',
  'landing.scenario.knowledge.feature.3': 'Tiered Permission Management',
  'landing.scenario.knowledge.feature.4': 'Knowledge Graph',
  'landing.scenario.knowledge.feature.5': 'Continuous Learning',

  'landing.scenario.document.tab': 'Document Intelligence',
  'landing.scenario.document.title': 'Supercharge Document Processing',
  'landing.scenario.document.desc': 'Contract review, financial statement analysis, legal document interpretation — AI completes in seconds what used to take hours.',
  'landing.scenario.document.metric.0.label': 'Contract Review Speed',
  'landing.scenario.document.metric.0.value': '20x',
  'landing.scenario.document.metric.1.label': 'Information Extraction Accuracy',
  'landing.scenario.document.metric.1.value': '98.5%',
  'landing.scenario.document.metric.2.label': 'Annual Cost Savings',
  'landing.scenario.document.metric.2.value': '$70K+',
  'landing.scenario.document.feature.0': 'PDF/Word Deep Parsing',
  'landing.scenario.document.feature.1': 'Key Contract Clause Extraction',
  'landing.scenario.document.feature.2': 'Financial Report Summary',
  'landing.scenario.document.feature.3': 'Multi-document Comparison',
  'landing.scenario.document.feature.4': 'Auto Risk Annotation',
  'landing.scenario.document.feature.5': 'Batch Processing',

  'landing.scenario.workflow.tab': 'Process Automation',
  'landing.scenario.workflow.title': 'Accelerate Every Business Process',
  'landing.scenario.workflow.desc': 'Visual workflow orchestration — hand off approvals, reports, and data sync to AI, integrating with DingTalk, Lark, SAP, Salesforce, and more.',
  'landing.scenario.workflow.metric.0.label': 'Process Automation Rate',
  'landing.scenario.workflow.metric.0.value': '85%',
  'landing.scenario.workflow.metric.1.label': 'Error Rate Reduction',
  'landing.scenario.workflow.metric.1.value': '92%',
  'landing.scenario.workflow.metric.2.label': 'ROI Payback Period',
  'landing.scenario.workflow.metric.2.value': '3 months',
  'landing.scenario.workflow.feature.0': 'Visual Workflow Designer',
  'landing.scenario.workflow.feature.1': 'Smart Conditional Branching',
  'landing.scenario.workflow.feature.2': 'Multi-system Data Sync',
  'landing.scenario.workflow.feature.3': 'Auto Anomaly Alerts',
  'landing.scenario.workflow.feature.4': 'Workflow Version Control',
  'landing.scenario.workflow.feature.5': 'Open API Integration',

  // ── Ecosystem ─────────────────────────────────────────────────────
  'landing.ecosystem.badge': 'Ecosystem',
  'landing.ecosystem.title': 'Connect Your Digital Enterprise',
  'landing.ecosystem.subtitle': '200+ pre-built enterprise connectors, ready out of the box, with custom API support for any platform',
  'landing.ecosystem.enterpriseSystems': 'Enterprise System Integrations',
  'landing.ecosystem.llmSupport': 'Large Language Model Support',

  'landing.integration.category.collab': 'Collaboration',
  'landing.integration.category.database': 'Database',
  'landing.integration.category.search': 'Search',
  'landing.integration.category.storage': 'Storage',
  'landing.integration.category.mq': 'Message Queue',

  'landing.api.rest.desc': 'Standard OpenAPI Specification',
  'landing.api.webhook.desc': 'Real-time Event Push',
  'landing.api.sdk.desc': 'Python / Node / Java',
  'landing.api.security.label': 'Enterprise Security',
  'landing.api.security.desc': 'SSO / OAuth2 / SAML',

  // ── Cases ─────────────────────────────────────────────────────────
  'landing.cases.badge': 'Case Studies',
  'landing.cases.title': 'Chosen by 500+ Enterprises',
  'landing.cases.subtitle': 'Real-world deployments across finance, manufacturing, retail, and government',
  'landing.cases.industryLabel': '{industry} Industry',
  'landing.cases.coveredIndustries': 'Industries Covered',

  'landing.case.bank.company': 'A Leading Joint-Stock Commercial Bank',
  'landing.case.bank.industry': 'Finance',
  'landing.case.bank.quote': 'Documents that used to take 3 senior compliance officers a week can now be reviewed by AI in 2 hours — with higher quality.',
  'landing.case.bank.author': 'Chief Compliance Officer',
  'landing.case.bank.result.0.metric': 'Review Efficiency',
  'landing.case.bank.result.0.value': '15x',
  'landing.case.bank.result.1.metric': 'Compliance Risk Reduction',
  'landing.case.bank.result.1.value': '78%',
  'landing.case.bank.result.2.metric': 'Annual Labor Cost Savings',
  'landing.case.bank.result.2.value': '$530K',

  'landing.case.mfg.company': 'A Large Manufacturing Group',
  'landing.case.mfg.industry': 'Manufacturing',
  'landing.case.mfg.quote': 'We digitized 20 years of process knowledge. New employees can now get up to speed in three weeks — something unimaginable before.',
  'landing.case.mfg.author': 'Group CIO',
  'landing.case.mfg.result.0.metric': 'New Employee Onboarding Time',
  'landing.case.mfg.result.0.value': '80% Shorter',
  'landing.case.mfg.result.1.metric': 'Technical Issue Response',
  'landing.case.mfg.result.1.value': '12x Faster',
  'landing.case.mfg.result.2.metric': 'Annual Training Cost Savings',
  'landing.case.mfg.result.2.value': '$725K',

  'landing.case.ecom.company': 'A Major E-commerce Platform',
  'landing.case.ecom.industry': 'E-commerce',
  'landing.case.ecom.quote': 'Peak customer service volume exceeded 500K sessions during promotions. AI handled all the load — and customer satisfaction was higher than ever.',
  'landing.case.ecom.author': 'Customer Service Director',
  'landing.case.ecom.result.0.metric': 'Auto-resolution Rate',
  'landing.case.ecom.result.0.value': '83%',
  'landing.case.ecom.result.1.metric': 'Support Staff Savings',
  'landing.case.ecom.result.1.value': '60%',
  'landing.case.ecom.result.2.metric': 'Customer NPS',
  'landing.case.ecom.result.2.value': '+42',

  'landing.industry.0': 'Banking & Finance',
  'landing.industry.1': 'Manufacturing',
  'landing.industry.2': 'Retail & E-commerce',
  'landing.industry.3': 'Healthcare',
  'landing.industry.4': 'Government Services',
  'landing.industry.5': 'Education & Training',
  'landing.industry.6': 'Real Estate',
  'landing.industry.7': 'Logistics & Transport',
  'landing.industry.8': 'Legal Services',
  'landing.industry.9': 'Energy & Chemicals',

  // ── Security ──────────────────────────────────────────────────────
  'landing.security.title': 'Enterprise-Grade Security You Can Trust',
  'landing.security.subtitle': 'Internationally certified, private deployment ready — your data stays in your hands',
  'landing.security.footer': 'Private deployment available · Complete data control · ',
  'landing.security.whitepaper': 'View Security Whitepaper →',

  'landing.security.encrypt.title': 'End-to-End Data Encryption',
  'landing.security.encrypt.badge': 'ISO 27001 Certified',
  'landing.security.encrypt.desc': 'Bank-grade encryption for data in transit and at rest, with regular security audits to keep your enterprise data absolutely safe.',
  'landing.security.access.title': 'Fine-Grained Access Control',
  'landing.security.access.badge': 'SOC 2 Type II',
  'landing.security.access.desc': 'Three-level permission system with full SSO / OAuth2 / SAML support, meeting enterprise compliance review requirements.',
  'landing.security.compliance.title': 'Compliance Assurance',
  'landing.security.compliance.badge': 'GDPR Compliant',
  'landing.security.compliance.desc': 'Private deployment supported — data fully under your control, compliant with global privacy regulations.',

  // ── Pricing ───────────────────────────────────────────────────────
  'landing.pricing.badge': 'Plans & Pricing',
  'landing.pricing.title': 'Choose the Right Plan for Your Organization',
  'landing.pricing.subtitle': 'From free trial to private deployment — solutions for enterprises of every scale',
  'landing.pricing.footer': 'All plans include a 14-day free trial · No credit card · Cancel anytime',

  'landing.pricing.starter.name': 'Starter',
  'landing.pricing.starter.price': 'Free',
  'landing.pricing.starter.priceNote': 'Free forever',
  'landing.pricing.starter.desc': 'Perfect for exploring AI collaboration capabilities',
  'landing.pricing.starter.cta': 'Get Started',
  'landing.pricing.starter.feature.0': 'Basic Knowledge Assistant',
  'landing.pricing.starter.feature.1': '20 Document Uploads',
  'landing.pricing.starter.feature.2': '5-person Team',
  'landing.pricing.starter.feature.3': 'Standard Support',
  'landing.pricing.starter.feature.4': 'Community Updates',

  'landing.pricing.pro.name': 'Professional',
  'landing.pricing.pro.price': 'Contact Us',
  'landing.pricing.pro.priceNote': 'Custom pricing',
  'landing.pricing.pro.desc': 'For SME teams, unlock full AI capabilities',
  'landing.pricing.pro.cta': 'Contact Sales',
  'landing.pricing.pro.badge': 'Most Popular',
  'landing.pricing.pro.feature.0': 'All Starter Features',
  'landing.pricing.pro.feature.1': 'Unlimited Document Uploads',
  'landing.pricing.pro.feature.2': 'Unlimited Users',
  'landing.pricing.pro.feature.3': 'API Access',
  'landing.pricing.pro.feature.4': 'Advanced Analytics',
  'landing.pricing.pro.feature.5': 'Dedicated Customer Success Manager',

  'landing.pricing.enterprise.name': 'Enterprise',
  'landing.pricing.enterprise.price': 'Custom Quote',
  'landing.pricing.enterprise.priceNote': 'Private · Customized',
  'landing.pricing.enterprise.desc': 'For large enterprises — a fully controlled private deployment',
  'landing.pricing.enterprise.cta': 'Get a Quote',
  'landing.pricing.enterprise.feature.0': 'All Professional Features',
  'landing.pricing.enterprise.feature.1': 'Private Deployment',
  'landing.pricing.enterprise.feature.2': 'Dedicated Implementation Consultant',
  'landing.pricing.enterprise.feature.3': 'SLA 99.9% Guarantee',
  'landing.pricing.enterprise.feature.4': 'Custom System Integration',
  'landing.pricing.enterprise.feature.5': 'Security Audit & Compliance',

  // ── CTA ───────────────────────────────────────────────────────────
  'landing.cta.title1': 'Ready to Let',
  'landing.cta.titleHighlight': ' AI ',
  'landing.cta.title2': 'Transform Your Enterprise?',
  'landing.cta.subtitle': 'Join 500+ leading enterprises and unlock a new frontier of AI efficiency with {title}. 14-day free trial with a dedicated onboarding consultant.',
  'landing.cta.emailPlaceholder': 'Enter your business email',
  'landing.cta.startFree': 'Start for Free',
  'landing.cta.perk.0': '14-day free trial, no credit card',
  'landing.cta.perk.1': 'Dedicated 1-on-1 implementation consultant',
  'landing.cta.perk.2': 'Secure data, private deployment available',
  'landing.cta.perk.3': '24/7 technical support',

  // ── Footer ────────────────────────────────────────────────────────
  'landing.footer.brand.desc': 'Building the AI intelligence application platform for enterprises — where AI truly drives business growth.',
  'landing.footer.product': 'Products',
  'landing.footer.solution': 'Solutions',
  'landing.footer.resource': 'Resources',
  'landing.footer.contact': 'Contact Us',
  'landing.footer.copyright': 'All rights reserved.',

  'landing.footer.product.0': 'Knowledge Assistant',
  'landing.footer.product.1': 'Document Intelligence',
  'landing.footer.product.2': 'Process Automation',
  'landing.footer.product.3': 'Data Analytics',
  'landing.footer.product.4': 'Enterprise API',

  'landing.footer.solution.0': 'Financial Industry',
  'landing.footer.solution.1': 'Manufacturing',
  'landing.footer.solution.2': 'Retail & E-commerce',
  'landing.footer.solution.3': 'Healthcare',
  'landing.footer.solution.4': 'Government Services',

  'landing.footer.resource.0': 'Developer Docs',
  'landing.footer.resource.1': 'Blog',
  'landing.footer.resource.2': 'Case Studies',
  'landing.footer.resource.3': 'Video Tutorials',
  'landing.footer.resource.4': 'Tech Community',

  'landing.footer.contact.0.label': 'Business Partnerships',
  'landing.footer.contact.0.val': 'sales@example.ai',
  'landing.footer.contact.1.label': 'Technical Support',
  'landing.footer.contact.1.val': 'support@example.ai',
  'landing.footer.contact.2.label': 'Media Inquiries',
  'landing.footer.contact.2.val': 'pr@example.ai',
  'landing.footer.contact.3.label': 'Partner Hotline',
  'landing.footer.contact.3.val': '+1-800-888-8888',

  'landing.footer.legal.0': 'Privacy Policy',
  'landing.footer.legal.1': 'Terms of Service',
  'landing.footer.legal.2': 'Security Whitepaper',
};
